import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Icon from 'components/icon';
import Heading from 'components/heading';

const baseThemes = {
  dark: 'dark',
  light: 'light'
};

const statuses = {
  done: 'done',
  current: 'current',
  notDone: 'not-done'
};

const HousingProjectTimeline = ({
  mainTitle = 'Tidslinje',
  events,
  baseTheme
}) => (
  <div
    className={cn('housing-project-timeline', {
      [`housing-project-timeline--${baseTheme}`]: baseTheme
    })}
  >
    <Heading className="housing-project-timeline__main-title" level={2}>
      {mainTitle}
    </Heading>
    {events.length > 0 && (
      <ol className="housing-project-timeline__events">
        {events.map(({ title, description, status }, index) => (
          <li
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            className={cn('housing-project-timeline__event', {
              [`housing-project-timeline__event--${status}`]: status
            })}
            aria-current={status === statuses.current ? 'step' : undefined}
          >
            <Heading
              className="housing-project-timeline__event-title"
              level={3}
            >
              {title}
            </Heading>
            {status === statuses.done ? (
              <Icon
                className="housing-project-timeline__event-checked-icon"
                name="check-circle-small"
                aria-label="Fullført"
              />
            ) : (
              <span
                className="housing-project-timeline__event-checked-icon"
                aria-hidden="true"
              />
            )}
            {description && (
              <p className="housing-project-timeline__event-description">
                {description}
              </p>
            )}
          </li>
        ))}
      </ol>
    )}
  </div>
);

HousingProjectTimeline.propTypes = {
  mainTitle: PropTypes.string,
  events: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string,
      status: PropTypes.oneOf(Object.values(statuses)).isRequired
    })
  ).isRequired,
  baseTheme: PropTypes.oneOf(Object.values(baseThemes))
};

HousingProjectTimeline.propTypesMeta = {
  baseTheme: 'exclude'
};

export default HousingProjectTimeline;
